const CLOUD_PAGE_OPT_OUT_MAX_AGE = 1707109200;

const CLOUD_PAGE_IAV2_OPT_OUT_COOKIE = {
  Name: 'cloud-page-iav2-opt-out',
  Options: {
    // accessible on all pages
    path: '/',
    // expires at max num days from now (400 days)
    'max-age': CLOUD_PAGE_OPT_OUT_MAX_AGE,
  },
};

const CLOUD_PAGE_IAV1_PATH_COOKIE = {
  Name: 'cloud-page-iav1-path',
  Options: {
    // accessible on all pages
    path: '/',
    // expires at max num days from now (400 days)
    'max-age': CLOUD_PAGE_OPT_OUT_MAX_AGE,
  },
};

export { CLOUD_PAGE_IAV2_OPT_OUT_COOKIE, CLOUD_PAGE_IAV1_PATH_COOKIE };
